export default {
  state: {
    paginatedErrorLogs: [],
    unresolvedCount: 0,
    loading: false,
    currentPage: 1,
    filterString: null,
    sorting: {
      prop: 'created_at',
      order: 'descending',
    },
  },
  getters: {
    paginatedErrorLogs: state => state.paginatedErrorLogs,
    unresolvedCount: state => state.unresolvedCount,
    loading: state => state.loading,
    currentPage: state => state.currentPage,
    sorting: state => state.sorting,
    filterString: state => state.filterString,
  },
  mutations: {
    setPaginatedErrorLogs(state, paginatedErrorLogs) {
      state.paginatedErrorLogs = paginatedErrorLogs;
    },
    setUnresolvedCount(state, count) {
      state.unresolvedCount = count;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
    setCurrentPage(state, currentPage) {
      state.currentPage = currentPage;
    },
    setSorting(state, sorting) {
      state.sorting = sorting;
    },
    setFilterString(state, filter) {
      state.filterString = filter;
    },
  },
  actions: {
    async fetchAllWithPagination({ commit, state }, queryString) {
      commit('setLoading', true);
      try {
        if (queryString) {
          commit('setCurrentPage', 1);
          commit('setFilterString', queryString.substr(1));
        } else if (queryString === '') {
          commit('setCurrentPage', 1);
          commit('setFilterString', '');
        } else {
          commit('setFilterString', state.filterString || '');
        }
        const query = `?page=${state.currentPage}&sortby=${state.sorting.prop}&sorttype=${state.sorting.order === 'ascending' ? 'asc' : 'desc'}&${state.filterString}`;
        const errorLogs = await axios.get('api/error-logs/paginated' + query);
        commit('setPaginatedErrorLogs', errorLogs);
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async fetchUnresolvedCount({ commit }) {
      try {
        const res = await axios.get('api/error-logs/paginated?resolved=0&per_page=1');
        commit('setUnresolvedCount', res.total || 0);
      } catch (e) {
      }
    },
    async resolve({ dispatch }, id) {
      await axios.post(`api/error-logs/${id}/resolve`);
      await dispatch('fetchAllWithPagination');
      dispatch('fetchUnresolvedCount');
    },
    async resolveRelated({ dispatch }, id) {
      await axios.post(`api/error-logs/${id}/resolve-related`);
      await dispatch('fetchAllWithPagination');
      dispatch('fetchUnresolvedCount');
    },
    async retry({ dispatch }, id) {
      try {
        await axios.post(`api/error-logs/${id}/retry`);
      } finally {
        await dispatch('fetchAllWithPagination');
        dispatch('fetchUnresolvedCount');
      }
    },
    async fetchXml(_context, id) {
      return axios.get(`api/error-logs/${id}/xml`);
    },
  },
};
